export default "__VITE_ASSET__Bb4RquGu__"